import { all, put, select, takeEvery } from 'redux-saga/effects';
import DashboardTypes from './DashboardTypes';
import createRequest from '../../api/httpRequest';
import API from '../../api/dashboard';
import snakecaseKeys from 'snakecase-keys';
import Util from '../../utils/Util';
import { getCompanyDomain } from '../company/companySelector';

function * loadNumberOfViews () {
  yield takeEvery(DashboardTypes.GET_NUMBER_OF_VIEWS_REQUEST, _loadNumberOfViews);
}

function * _loadNumberOfViews ({ payload }) {
  const params = snakecaseKeys(payload);
  yield createRequest({
    api: {
      ...API.GET_NUMBER_OF_VIEWS,
      params: params
    },
    onSuccess: function * (response) {
      yield put({
        type: DashboardTypes.GET_NUMBER_OF_VIEWS_SUCCESS,
        payload: Util.toCamelCaseKey(response.data)
      });
    }
  });
}

function * loadViewsPerSection () {
  yield takeEvery(DashboardTypes.GET_VIEWS_PER_SECTION_REQUEST, _loadViewsPerSection);
}

function * _loadViewsPerSection ({ payload }) {
  const params = snakecaseKeys(payload);
  yield createRequest({
    api: {
      ...API.GET_VIEWS_PER_SECTION,
      params: params
    },
    onSuccess: function * (response) {
      yield put({
        type: DashboardTypes.GET_VIEWS_PER_SECTION_SUCCESS,
        payload: Util.toCamelCaseKey(response.data)
      });
    }
  });
}

function * loadNumberOfUniqueVisitors () {
  yield takeEvery(DashboardTypes.GET_NUMBER_OF_UNIQUE_VISITOR_REQUEST, _loadNumberOfUniqueVisitors);
}

function * _loadNumberOfUniqueVisitors ({ payload }) {
  const params = snakecaseKeys(payload);
  yield createRequest({
    api: {
      ...API.GET_NUMBER_OF_UNIQUE_VISITOR,
      params: params
    },
    onSuccess: function * (response) {
      yield put({
        type: DashboardTypes.GET_NUMBER_OF_UNIQUE_VISITOR_SUCCESS,
        payload: Util.toCamelCaseKey(response.data)
      });
    }
  });
}

function * loadTop50SearchTerms () {
  yield takeEvery(DashboardTypes.GET_TOP_50_SEARCH_TERMS_REQUEST, _loadTop50SearchTerms);
}

function * _loadTop50SearchTerms ({ payload }) {
  const params = snakecaseKeys(payload);
  yield createRequest({
    api: {
      ...API.GET_TOP_50_SEARCH_TERMS,
      params: params
    },
    onSuccess: function * (response) {
      yield put({
        type: DashboardTypes.GET_TOP_50_SEARCH_TERMS_SUCCESS,
        payload: Util.toCamelCaseKey(response.data)
      });
    }
  });
}

function * updateView () {
  yield takeEvery(DashboardTypes.UPDATE_VIEW_REQUEST, _updateView);
}

function * _updateView ({ payload }) {
  const domain = yield select(getCompanyDomain);
  const request = snakecaseKeys({ ...payload, domain });
  yield createRequest({
    api: {
      ...API.UPDATE_VIEW,
      params: request
    }
  });
}

function * updateUniqueVisitor () {
  yield takeEvery(DashboardTypes.UPDATE_UNIQUE_VISITOR_REQUEST, _updateUniqueVisitor);
}

function * _updateUniqueVisitor ({ payload }) {
  const domain = yield select(getCompanyDomain);
  const request = snakecaseKeys({ ...payload, domain });
  yield createRequest({
    api: {
      ...API.UPDATE_UNIQUE_VISITOR,
      params: request
    }
  });
}

function * updateSectionView () {
  yield takeEvery(DashboardTypes.UPDATE_SECTION_VIEW_REQUEST, _updateSectionView);
}

function * _updateSectionView ({ payload }) {
  const domain = yield select(getCompanyDomain);
  const request = snakecaseKeys({ ...payload, domain });
  yield createRequest({
    api: {
      ...API.UPDATE_SECTION_VIEW,
      params: request
    }
  });
}

export default function * dashboardSaga () {
  yield all([
    loadNumberOfViews(),
    loadViewsPerSection(),
    loadNumberOfUniqueVisitors(),
    loadTop50SearchTerms(),
    updateView(),
    updateUniqueVisitor(),
    updateSectionView()
  ]);
}
